(ns app.front.view.group.admin.letter.party-snippet-editor
  (:require [app.domain.party.model :as party-model]
            [app.front.ui.text-editor :as text-editor]
            [app.front.view.group.admin.templates.document-editor :as document-editor])
  (:require-macros [core.util.util :as util]))

(def editor-data
  [{:title        :letter/applicant-snippet
    :fragment     :letter-fragment/applicant-snippet
    :placeholders party-model/snippet-variables}
   {:title        :letter/property-owner-snippet
    :fragment     :letter-fragment/property-owner-snippet
    :placeholders party-model/snippet-variables}
   {:title        :letter/party-snippet
    :fragment     :letter-fragment/party-snippet
    :placeholders party-model/snippet-variables}])

(defn snippet-editor [{:keys [title
                              fragment
                              placeholders]}
                      {:keys [get-external-edit-state-key
                              tr
                              inherited?
                              images
                              group-id
                              document-id]}]
  [document-editor/editor
   (-> (util/mmap {:title              [:h4 (tr [title])]
                   :placeholders       placeholders
                   :read-only?         inherited?
                   :small?             true
                   :html-fragment-type fragment}
                  tr images group-id document-id)
       (text-editor/with-external-edit-state (get-external-edit-state-key fragment)))])

(defn party-snippets-editor [{:keys [visible-fragment-types] :as snippet-editor-ctx}]
  (->> editor-data
       (keep (fn [editor-data]
               (when (contains? visible-fragment-types (:fragment editor-data))
                 [snippet-editor editor-data snippet-editor-ctx])))
       (into [:<>])))
